import { type Unit } from '../../../store/slices/unitsSlice'

export const getUnitAddress = (currentUnit: Unit): string => {
    const unitAddress = `${currentUnit?.attributes?.Marketing?.Headline ? currentUnit.attributes?.Marketing?.Headline : 'Unit'} ${currentUnit?.attributes?.Marketing?.Headline?.includes('Unit') ? '' : currentUnit?.attributes?.Number ?? ''}`
    return unitAddress
}








